import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import api from './api/api'
import global from './utils/global'
import filters from '@/utils/filters'
import './assets/css/global.css'
import {
  Button, Input, Checkbox, Tabs, TabPane, Row, Col, Popover, Dialog, MessageBox,
  Menu, MenuItem,Steps, Step, Cascader, Select, Option, Form, FormItem, Divider,
  Upload, Message, Radio, Drawer, Avatar, Carousel, CarouselItem, Dropdown,
  DropdownMenu,DropdownItem,
} from 'element-ui'


Vue.use(Button).use(Input).use(Checkbox).use(Select).use(Option).use(Form).use(FormItem)
Vue.use(Tabs).use(TabPane).use(Row).use(Col).use(Popover).use(Dialog)
Vue.use(Menu).use(MenuItem).use(Steps).use(Step).use(Cascader)
Vue.use(Divider).use(Upload).use(Radio).use(Drawer).use(Avatar).use(Carousel)
Vue.use(CarouselItem).use(Dropdown).use(DropdownMenu).use(DropdownItem)


Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox

Vue.config.productionTip = false

Vue.prototype.$host = 'http://uumapi.ddzzii.com'
Vue.prototype.$api = api
Vue.prototype.$G = global
Vue.prototype.$cookies = VueCookies

Vue.use(VueCookies)

Vue.filter('dateFormat', filters.dateFormat)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
